export enum CookieKey {
  isReturner = 'IS_RETURNER',
  onPageTimer = 'ON_PAGE_TIMER',
}
